import { render } from "./ErrorValidacionNomina.vue?vue&type=template&id=98e5af12"
import script from "./ErrorValidacionNomina.vue?vue&type=script&lang=js"
export * from "./ErrorValidacionNomina.vue?vue&type=script&lang=js"

import exportComponent from "C:\\agentcloudALProd\\_work\\12\\s\\AEL.NominaElectronica.Web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__